import React from 'react';

const shimmerDelay = (ms) => ({'--shimmer-delay': `${ms}ms`});

function SkeletonField({delay = 0}) {
    return (
        <div className="col-md-6 skeleton-field" style={{animationDelay: `${delay}ms`}}>
            <div className="clinic-info-field d-flex align-items-center">
                <span
                    className="skeleton-block skeleton-circle me-2 flex-shrink-0"
                    style={{width: 22, height: 22, ...shimmerDelay(delay + 80)}}
                />
                <div className="flex-grow-1">
                    <span className="skeleton-block mb-1 d-block" style={{height: 10, width: '35%', ...shimmerDelay(delay + 120)}}/>
                    <span className="skeleton-block d-block" style={{height: 12, width: '70%', ...shimmerDelay(delay + 160)}}/>
                </div>
            </div>
        </div>
    );
}

function SkeletonSectionTitle({width = '28%', delay = 0}) {
    return (
        <div className="col-12 skeleton-field mb-1" style={{animationDelay: `${delay}ms`}}>
            <span className="skeleton-block d-block" style={{height: 18, width, ...shimmerDelay(delay + 40)}}/>
        </div>
    );
}

function GatewayClinicInfoSkeleton() {
    let fieldIndex = 0;
    const nextDelay = () => {
        const delay = fieldIndex * 70;
        fieldIndex += 1;
        return delay;
    };

    return (
        <div className="sms-skeleton clinic-info-content">
            <section className="clinic-info-form-section">
                <div className="row clinic-info-fields g-4">
                    <SkeletonSectionTitle width="28%" delay={nextDelay()}/>
                    <SkeletonField delay={nextDelay()}/>
                    <SkeletonField delay={nextDelay()}/>
                    <SkeletonField delay={nextDelay()}/>
                    <SkeletonField delay={nextDelay()}/>
                    <SkeletonField delay={nextDelay()}/>
                    <SkeletonField delay={nextDelay()}/>
                    <SkeletonField delay={nextDelay()}/>

                </div>
            </section>

            <hr className="clinic-info-divider skeleton-divider"/>

            <section className="clinic-info-form-section mb-0">
                <div className="row clinic-info-fields g-4">
                    <SkeletonSectionTitle width="32%" delay={nextDelay()}/>
                    <SkeletonField delay={nextDelay()}/>
                    <SkeletonField delay={nextDelay()}/>
                    <SkeletonField delay={nextDelay()}/>
                    <SkeletonField delay={nextDelay()}/>
                    <SkeletonField delay={nextDelay()}/>

                </div>
            </section>

            <hr className="clinic-info-divider skeleton-divider"/>

            <section>
                <div className="row clinic-info-fields g-4">
                    <SkeletonSectionTitle width="30%" delay={nextDelay()}/>
                    {[1, 2, 3].map((i) => (
                        <div key={i} className="col-md-4 skeleton-field" style={{animationDelay: `${nextDelay()}ms`}}>
                            <div className="clinic-info-field d-flex align-items-center">
                                <span className="skeleton-block skeleton-circle me-2 flex-shrink-0" style={{width: 22, height: 22}}/>
                                <div className="flex-grow-1">
                                    <span className="skeleton-block mb-1 d-block" style={{height: 10, width: '50%'}}/>
                                    <span className="skeleton-block d-block" style={{height: 12, width: '30%'}}/>
                                </div>
                            </div>
                        </div>
                    ))}

                </div>
            </section>
        </div>
    );
}

export default GatewayClinicInfoSkeleton;
